/* Sticky Johnson "Send us a clip" (sections/sj-clip-submit.liquid).
   With an upload endpoint set: on submit, the chosen file is uploaded straight into Shopify Files
   (endpoint "stage" -> POST the file to Shopify's staged-upload target with progress -> endpoint "finalize"),
   the file's name/link goes into a hidden contact field, then the normal Shopify contact form submits.
   No endpoint or no JS: the plain link field is used. */
(function () {
  function init(form) {
    if (form.__sjClip) return;
    form.__sjClip = true;
    // ?rider=<name> (from "Send us a clip of <rider>" on profiles) preselects the rider
    try {
      var want = new URLSearchParams(location.search).get('rider');
      var sel = form.querySelector('select[name="contact[Rider in the clip]"]');
      if (want && sel) {
        for (var i = 0; i < sel.options.length; i++) {
          if (sel.options[i].value.toLowerCase() === want.trim().toLowerCase()) { sel.selectedIndex = i; break; }
        }
      }
    } catch (e) {}
    var endpoint = form.getAttribute('data-endpoint');
    var maxMb = parseFloat(form.getAttribute('data-max-mb')) || 1000;
    var fileWrap = form.querySelector('[data-sj-clip-file]');
    if (!endpoint || !fileWrap) return;

    var input = fileWrap.querySelector('input[type=file]');
    var progress = form.querySelector('[data-sj-clip-progress]');
    var bar = form.querySelector('[data-sj-clip-bar]');
    var status = form.querySelector('[data-sj-clip-status]');
    var result = form.querySelector('[data-sj-clip-result]');
    var errorEl = form.querySelector('[data-sj-clip-error]');
    var submitBtn = form.querySelector('[data-sj-clip-submit]');
    var linkInput = form.querySelector('[data-sj-clip-link] input');
    var text = {};
    try { text = JSON.parse(form.querySelector('[data-sj-clip-text]').textContent); } catch (e) {}
    fileWrap.hidden = false;

    var busy = false;
    var done = false;

    function showError(msg) { errorEl.textContent = msg; errorEl.hidden = !msg; }
    function setProgress(pct, msg) {
      progress.hidden = false;
      bar.style.width = Math.round(pct) + '%';
      if (msg) status.textContent = msg + (pct < 100 ? ' ' + Math.round(pct) + '%' : '');
    }
    function call(body) {
      return fetch(endpoint, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) })
        .then(function (r) { return r.json().then(function (j) { if (!r.ok || j.error) throw new Error(j.error || r.status); return j; }); });
    }
    function upload(target, file) {
      return new Promise(function (resolve, reject) {
        var fd = new FormData();
        target.parameters.forEach(function (p) { fd.append(p.name, p.value); });
        fd.append('file', file);
        var xhr = new XMLHttpRequest();
        xhr.open('POST', target.url);
        xhr.upload.onprogress = function (e) { if (e.lengthComputable) setProgress(e.loaded / e.total * 95, text.uploading); };
        xhr.onload = function () { (xhr.status >= 200 && xhr.status < 300) ? resolve() : reject(new Error('upload ' + xhr.status)); };
        xhr.onerror = function () { reject(new Error('network')); };
        xhr.send(fd);
      });
    }
    function field(name) { var el = form.querySelector('[name="contact[' + name + ']"]'); return el ? el.value : ''; }

    form.addEventListener('submit', function (e) {
      if (done) return; // second pass: let the normal contact form submit
      e.preventDefault();
      if (busy) return;
      showError('');
      var file = input.files && input.files[0];
      var link = linkInput ? linkInput.value.trim() : '';
      if (!file && !link) { showError(text.need_file || ''); input.focus(); return; }
      if (!form.reportValidity()) return;
      if (!file) { done = true; form.submit(); return; }
      if (file.size > maxMb * 1024 * 1024) { showError(text.too_big || ''); return; }

      busy = true;
      submitBtn.disabled = true;
      setProgress(0, text.uploading);
      var meta = { rider: field('Rider in the clip'), name: field('name'), instagram: field('Instagram'), spot: field('Spot') };
      call({ action: 'stage', filename: file.name, mimeType: file.type || 'application/octet-stream', fileSize: file.size })
        .then(function (t) { return upload(t, file).then(function () { return t; }); })
        .then(function (t) {
          setProgress(97, text.finishing);
          return call({ action: 'finalize', resourceUrl: t.resourceUrl, resource: t.resource, filename: file.name, meta: meta });
        })
        .then(function (f) {
          setProgress(100, text.finishing);
          result.value = file.name + (f.adminUrl ? ' – ' + f.adminUrl : '') + (f.fileId ? ' (' + f.fileId + ')' : '');
          done = true;
          form.submit();
        })
        .catch(function () {
          busy = false;
          submitBtn.disabled = false;
          progress.hidden = true;
          showError(text.failed || '');
        });
    });
  }
  function all() { document.querySelectorAll('form[data-sj-clip]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', all); else all();
  document.addEventListener('shopify:section:load', all);
})();
